import type { ViewStyle } from 'react-native';

import { getStyleSheet } from './style-sheet-memo';

export const position = (position: ViewStyle['position']) =>
  getStyleSheet({ position });

export const zIndex = (zIndex: ViewStyle['zIndex']) =>
  getStyleSheet({ zIndex });

export const top = (top: ViewStyle['top']) => getStyleSheet({ top });

export const right = (right: ViewStyle['right']) => getStyleSheet({ right });

export const bottom = (bottom: ViewStyle['bottom']) =>
  getStyleSheet({ bottom });

export const left = (left: ViewStyle['left']) => getStyleSheet({ left });
